import qs from 'qs';
export const currentPageFromLocation = (location) =>
  +qs.parse(location.search, { ignoreQueryPrefix: true }).page || 1;
